import React, { PureComponent } from 'react';
import { SpinnerWrapper } from './Spinner.styles';
import { ISpinnerProps } from './Spinner.types';

export default class Spinner extends PureComponent<ISpinnerProps> {
  render() {
    const { width = 32, height = 32 } = this.props;

    return <SpinnerWrapper width={width} height={height} />;
  }
}
